// @import components
import SVG from 'components/renderSvg';
//@import user rights
import { userRights } from './userRights';
// @import media
import home from 'media/svgs/sidebar/home.svg';
import blackHome from 'media/svgs/sidebar/black_home_icon.svg';

import service from 'media/svgs/sidebar/cards-2.svg';
import blackService from 'media/svgs/sidebar/black_services_icon.svg';

import sales from 'media/svgs/sidebar/package.svg';
import blackSales from 'media/svgs/sidebar/black_sales_icon.svg';

import staff from 'media/svgs/sidebar/whistle.svg';
import blackStaff from 'media/svgs/sidebar/black_staff_icon.svg';

import finance from 'media/svgs/sidebar/wallet.svg';
import blackFinance from 'media/svgs/sidebar/black_finance_icon.svg';

import operations from 'media/svgs/sidebar/configuration.svg';
import blackOperations from 'media/svgs/sidebar/black_operations_icon.svg';

import trend from 'media/svgs/sidebar/chart-increase.svg';
import blackTrend from 'media/svgs/sidebar/black_trends_icon.svg';

import sponsorships from 'media/svgs/sidebar/target-arrow.svg';
import blackSponsorships from 'media/svgs/sidebar/black_challenges_icon.svg';

import ranking from 'media/svgs/sidebar/ranking.svg';
import blackRanking from 'media/svgs/sidebar/black_ranking_icon.svg';

import messagingIcon from 'media/svgs/sidebar/message.svg';
import arenaIcon from 'media/svgs/sidebar/ranking.svg';
import blackArenaIcon from 'media/svgs/sidebar/black_ranking_icon.svg';

export const SidebarRoutes = [
  {
    path: '/',
    icon: <SVG icon={home} className='' />,
    activeIcon: <SVG icon={blackHome} className='' />,
    name: 'Home',
  },
  {
    path: '/messages',
    icon: <SVG icon={messagingIcon} className='' />,
    activeIcon: <SVG icon={messagingIcon} className='' />,
    name: 'Messages',
  },
  {
    path: '/arena',
    icon: <SVG icon={arenaIcon} className='' />,
    activeIcon: <SVG icon={blackArenaIcon} className='' />,
    name: 'Arena',
  },
  {
    path: '/services',
    icon: <SVG icon={service} className='' />,
    activeIcon: <SVG icon={blackService} className='' />,
    name: 'Services',
  },
  {
    path: '/sales',
    icon: <SVG icon={sales} className='' />,
    activeIcon: <SVG icon={blackSales} className='' />,
    name: 'Sales',
  },
  {
    path: '/staff',
    icon: <SVG icon={staff} className='' />,
    activeIcon: <SVG icon={blackStaff} className='' />,
    name: 'Staff',
  },
  {
    path: '/finance',
    icon: <SVG icon={finance} className='' />,
    activeIcon: <SVG icon={blackFinance} className='' />,
    name: 'Finance',
  },
  {
    path: '/operations',
    icon: <SVG icon={operations} className='' />,
    activeIcon: <SVG icon={blackOperations} className='' />,
    name: 'Operations',
  },
  {
    path: '/trends',
    icon: <SVG icon={trend} className='' />,
    activeIcon: <SVG icon={blackTrend} className='' />,
    name: 'Trends',
  },
  {
    path: '/sponsorships',
    icon: <SVG icon={sponsorships} className='' />,
    activeIcon: <SVG icon={blackSponsorships} className='' />,
    name: 'Sponsorships',
  },
  {
    path: '/challenges',
    icon: <SVG icon={ranking} className='' />,
    activeIcon: <SVG icon={blackRanking} className='' />,
    name: 'Challenges',
  },
];
